import { render } from "./scholarship.vue?vue&type=template&id=50d81992&ts=true"
import script from "./scholarship.vue?vue&type=script&lang=ts"
export * from "./scholarship.vue?vue&type=script&lang=ts"

import "./scholarship.vue?vue&type=style&index=0&id=50d81992&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__